module.exports = __webpack_public_path__ + "img/QA_pc.bd0d86ed.jpg";